import { Amplify } from 'aws-amplify';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import * as React from 'react';

import { FullPageLazyLoadingFallback } from '@/components/Loaders/FullPageLazyLoadingFallback';
import type { ReactChildrenType } from '@/types';
import { postDebugLogs } from '@/utils/postDebugLogs';

import { getAuthConfigAws } from './config';

// const BUFFER_EXPIRATION_TIME = 30;

const AuthProviderAws: React.FunctionComponent<ReactChildrenType> = ({
  children,
}) => {
  const [isAuthInitialized, setIsAuthInitialized] = React.useState(false);

  React.useEffect(() => {
    if (import.meta.env.VITE_CLOUD_PROVIDER === 'aws') {
      Amplify.configure({
        Auth: getAuthConfigAws(),
      });
    }
    setIsAuthInitialized(true);
  }, []);

  if (!isAuthInitialized) {
    return <FullPageLazyLoadingFallback />;
  }

  return <>{children}</>;
};

const getIdTokenAws = async () => {
  try {
    // let session = await fetchAuthSession();
    // let idToken = session.tokens?.idToken;
    // if (!idToken) {
    //   throw new Error('No ID token found in session');
    // }
    // const currentTime = Math.floor(Date.now() / 1000);
    // const expirationTime = idToken.payload.exp || 0;
    // const isIDTokenExpired =
    //   expirationTime - BUFFER_EXPIRATION_TIME < currentTime;
    // if (isIDTokenExpired) {
    //   session = await forceRefreshTokensAws();
    //   idToken = session.tokens?.idToken;
    //   if (!idToken) {
    //     throw new Error('No ID token after refresh');
    //   }
    // }
    // return idToken?.toString();
    const session = await fetchAuthSession();
    if (!session.tokens || !session.tokens.idToken) {
      throw new Error('Auth session is missing tokens or idToken.');
    }
    return session.tokens.idToken.toString();
  } catch (error) {
    postDebugLogs('Failed to refresh tokens. Signing out user');
    await signOutAws();
  }
};

const isAuthenticatedAws = async () => {
  try {
    const session = await fetchAuthSession();
    return !!session.tokens;
  } catch (error) {
    return false;
  }
};

const signOutAws = async () => {
  await signOut();
};

const forceRefreshTokensAws = async () => {
  return await fetchAuthSession({
    forceRefresh: true,
  });
};

export {
  AuthProviderAws,
  getIdTokenAws,
  isAuthenticatedAws,
  signOutAws,
  forceRefreshTokensAws,
};
